module.exports = __webpack_public_path__ + "img/avatar7.4b357799.png";